import Translation from "@/services/Translation/Translation";
import engine from "@/engine";

// Store initialization is located in @/services/Translation/Translation initStore()
// For every form entrypoint is called engine.translation.store = engine.translation.initStore();

// Get translation string
const t = (
  path: string = "",
  identifier: string = "",
  data: any[] = [],
  lang: string = Translation.currentLanguage
) => {
  const fallbackLang: string = Translation.defaultLanguage;
  const stringPath: string = identifier ? identifier + "." + path : path;

  // Call Pinia getter from TranslationsStore.ts and return translation string
  const value = engine.translation.store.getData(stringPath, true, lang, fallbackLang);

  // Check if have syntax
  if(value && data && data.length > 0) {
    if(checkSyntax(value)) {
      // Return plurality translation string
      return plurality(value, data);
    } else {
      return value ? value : '';
    }
  } else {
    return value ? value : '';
  }
}

// Static translation
const ts = (inputString: string, data: any[]) => {
  // Check if have syntax
  if(inputString && data && data.length > 0) {
    if(checkSyntax(inputString)) {
      // Return plurality translation string
      return plurality(inputString, data);
    } else {
      return inputString ? inputString : '';
    }
  } else {
    return inputString ? inputString : '';
  }
}

// Check plurality syntax
const checkSyntax = (inputString: string) => {
  // #[]# ${}$ [$X]
  const regex = /#\[(.*?)\]#|\{\$[^\$]*\$\}|\[\$[A-Za-z0-9]+\]/g;
  const matches = inputString.match(regex);

  return matches && matches.length > 0;  
}

// Plurality
// Plurality example: "Máte #[{$0-0-1$}zapísanú [$0] položku]##[{$0-2-4$}zapísané [$0] položky]##[{$0-5$}zapísaných [$0] položkiek]# a [$1] podpoložiek. #[{$2-1-1$}Ďakujem]##[{$2-2$}Ďakujeme]#" 
const plurality = (
  templateString: string = "",
  data: any[] = [],
) => {
  let finalString = '';
  const regex = /#\[(.*?)\]#/g; // Sections #[...]#

  // Get sections from string, add split string |&~@| and split
  const splitString = templateString
    .replace(regex, (match, captured) => `|&~@|#[${captured}]#|&~@|`)
    .split('|&~@|')
    .filter(part => part !== '');

  // Loop string sections
  for(const i in splitString) {
    let part = splitString[i];
    // If is section #[...]#
    if(part.match(regex)) {
      // Process condition {$X-X-X$}
      let condition: any|null  = processCondition(part, data);
      if(condition) {
        // If condition is valid, add to final translation string
        finalString += condition.message;
      }
    } else {
      // If is not section, add to final translation string without processing
      finalString += part;
    }
  }

  // Replace all data variables [$i]
  for(const i in data) {
    finalString = finalString.replace("[$" + i + "]", data[i]);
  }

  // return final translation
  return finalString;
}

// Process condition for plurality
const processCondition = (part: string, data: any[]): any|null => {
  if (!part || !data) return null;
  // Get section content inside #[...]#
  const outerRegex = /#\[(.*?)\]#/;
  const outerMatch = part.match(outerRegex);
  if (!outerMatch) return null;

  // Get condition content inside {$X-X-X$}
  const regex = /\{\$(.*?)\$\}/;
  const match = outerMatch[1].match(regex);
  if (!match) return null;

  // Array of condition values, data index, minimum value, maximum value 
  const values = match[1].split('-').map((value, index) => {
    return parseInt(value);
  });
  const [dataIndex, valueMin, valueMax] = values;

  // Get part of translation string without syntax
  const message = outerMatch[1].replace(match[0], '');

  // Final data for plurality function
  let finalValue = {
    dataIndex: dataIndex,
    message: message,
  }

  // Run condition if we can use this string for translation. Return finalValue or null.
  const inputValue = data[dataIndex];
  if (!inputValue && !valueMin) return null;
  if ((valueMax && inputValue >= valueMin && inputValue <= valueMax) || (!valueMax && inputValue >= valueMin)) {
    return finalValue;
  }
}

// Use for IF statement. Return raw value or undefined.
const tRaw = (
  path: string = "",
  lang: string = Translation.currentLanguage
) => {
  const fallbackLang: string = Translation.defaultLanguage;

  // Call Pinia getter from TranslationsStore.ts and return if translation string exist
  return engine.translation.store.getData(path, false, lang, fallbackLang);
}

// Set or change translation string
const tSet = (
  string: string,
  path: string = "",
  identifier: string = "",
  createIfMissing: boolean = false,
  lang: string = Translation.currentLanguage
) => {
  const stringPath: string = identifier + "." + path;

  // Call Pinia action from TranslationsStore.ts
  engine.translation.store.setData(stringPath, string, createIfMissing, lang);
}

export {t, ts, tSet, tRaw}
